<!--
 * @Author: nathan
 * @Date: 2023-10-19 09:15:10
 * @LastEditors: nathan
 * @LastEditTime: 2024-03-21 13:44:19
 * @FilePath: /insurance-group-pc/src/components_v3/layout/layout.vue
 * @Description:
 *
 * Copyright (c) 2024 by 用户/公司名, All Rights Reserved.
-->
<template>
    <el-container class="intention-apply container_100">
        <el-aside class="left-sider-wraper" width="17%">
            <el-container class="container_100">
                <el-header :height="headerH" class="intention-apply-logo">
                    <template v-if="isTXSystem">
                        <img style="margin-right: 6px;" src="../../images/tx-logo.png" alt="">
                        <div>{{ agencyName }}</div>
                    </template>
                    <template v-else>
                        <img :src="logoImg" alt="">
                    </template>
                </el-header>
                <el-main class="container_main">
                    <left-sider />
                </el-main>
            </el-container>
        </el-aside>
        <el-container class="intention-apply-container">
            <el-header :height="headerH" class="intention-apply-header" style="z-index:2">
                <div class="flex1">
                    <i class="el-icon-s-fold icon"></i>
                    <div class="title">{{menuTitle}}</div>
                </div>
                <div class="user-box">
                    <div class="imgbox">
                        <img v-if="isTXSystem" style="margin-right: 6px;" src="../../images/tx-avatar.png" alt="">
                        <img v-else :src="userLogo" class="imgbox-img" alt="">
                    </div>
                    <div class="name">{{userName}}</div>
                    <div class="exit-box" @click="click_logout">
                        <img class="exitImg" :src="exitImg" alt="">
                    </div>
                </div>
            </el-header>
            <el-main class="container_main intention-apply-main" id="main">
                <router-view :key="$route.fullPath"/>
                <!-- 一些页面不需要公共的footer -->
                <template v-if="isShowFooter">
                    <c-footer-new :isTXSystem="isTXSystem" class="footer-wraper"></c-footer-new>
                </template>
            </el-main>
        </el-container>
        <mobile-url ref="mobileUrl" />
    </el-container>
    <!-- <div class="main">
        <router-view :key="$route.fullpath"/>
    </div> -->
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import leftSider from './left-sider';
import { cookie }  from 'tools';
import { DOMAIN } from '_libs/host';
import { $getH5Url } from '_libs/util';
import CFooterNew from '_c/www2/c-footer.vue'
import mobileUrl from '_c3/product/mobile-url.vue'
import { getPcCompatibleUrl } from '@/util/url'

import { ENUM_TRANSFER_H5_PAGE_TYPE, ENUM_PRODUCT_TYPE, ENUM_INSURE_JUMP_PAGE_TYPE, COMMON_TRANSFER_PAGE_NAME, CPS_REDIRECT_PAGE_NAME } from '../../views/data-models';
export default {
    name: 'layout',
    data() {
        return {
            collapsed: false,
            headerH: '80px',
            logoImg: 'https://res.wyins.net/autoUpload/group/b92dbc00-b492-4274-af81-74cbed4de9de.png',
            exitImg: 'https://res.wyins.net/autoUpload/group/7970d9b2-4c89-40b9-b3b9-4f8aa76125d7.png',
            excludeFooterPathRouters: ['/quotationShow']
        }
    },
    methods: {
        click_logout(){
            this.$store.dispatch('Logout').then(rep => {
                cookie('token',null,{domain: DOMAIN});
                this.$tipsMessage(rep.info || '登出成功',1);
                // this.$router.push('/entry');
                if (this.$store.getters.goPageAfterLogin) {
                    this.$router.push(this.$store.getters.goPageAfterLogin)
                    this.$store.commit('SET_GO_PAGE', '')
                } else {
                    this.$router.go(0)
                }
            });
        },
    },
    components: {
        leftSider,
        CFooterNew,
        mobileUrl,
    },
    provide() {
        const vm = this
        return {
            goWrite3rdParty(productBaseInfo) {
                const { insureJumpPageType, transferH5PageType, transferH5PageLink, productType, productId } = productBaseInfo;
                let targetUrl = '';
                if (insureJumpPageType === ENUM_INSURE_JUMP_PAGE_TYPE.DETAIL_AND_QUOTATION && productType === ENUM_PRODUCT_TYPE.CPS) {
                    targetUrl = $getH5Url(CPS_REDIRECT_PAGE_NAME, { productId })
                } else {
                    targetUrl = transferH5PageType === ENUM_TRANSFER_H5_PAGE_TYPE.CUSTOMIZED ? getPcCompatibleUrl(transferH5PageLink) : $getH5Url(COMMON_TRANSFER_PAGE_NAME, { productId })
                }
                if (!targetUrl) {
                    vm.$message.error('产品解析出错：无效的跳转地址');
                    console.error('Product_Detail_3 无效的跳转地址:', { productId, transferH5PageType, transferH5PageLink, targetUrl });
                    return;
                }
                if (productType === ENUM_PRODUCT_TYPE.CPS) {
                    // 保司/第三方页面通常是适配 PC 端的
                    window.open(targetUrl, '_blank');
                } else {
                    vm.$refs.mobileUrl.open(targetUrl);
                }
            },
        }
    },
    computed: {
        isShowFooter() {
            for (let i = 0; i < this.excludeFooterPathRouters.length; i++) {
                console.log(this.$route.fullPath.includes(this.excludeFooterPathRouters[i]))
                if (this.$route.fullPath.includes(this.excludeFooterPathRouters[i])) {
                    return false;
                }
            }
            return true;
        },
        ...mapState({
            menuTitle: state => state.user.menuTitle,
        }),
        ...mapGetters([
            "userLogo",
            "userName",
            "isTXSystem",
            "agencyName"
        ]),
    },
}
</script>
<style lang="less">
@import "./layout.less";
</style>




// WEBPACK FOOTER //
// src/components_v3/layout/layout.vue